import { render, staticRenderFns } from "./confirmlistdataviews.vue?vue&type=template&id=456a717a"
import script from "./confirmlistdataviews.vue?vue&type=script&lang=js"
export * from "./confirmlistdataviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports